// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SHwmB","content":"styles_content__KLwVN"};